import { Reducer } from 'umi';

const namespace = 'opinionMarketingMenu';

type TStateType = {
  menuExpand: boolean;
  listMenu: Array<any>;
  listMenuLoading: boolean;
};

const customModel: {
  namespace: string;
  state: TStateType;
  reducers: {
    save: Reducer<TStateType>;
    toggleMenuExpand: Reducer<TStateType>;
  };
} = {
  namespace,
  state: {
    menuExpand: true,
    listMenu: [
      {
        title: 'Hotspot Radar',
        titleCn: '行业热点洞察',
        icon: 'radar',
        children: [
          { title: 'Memes', titleCn: '行业热梗', href: '/marketing/Memes', hasBeta: true },
          { title: 'Hashtag', titleCn: 'Hashtag', href: '/marketing/Hashtag' },
          { title: 'Videos', titleCn: '视频', href: '/marketing/Videos' },
        ],
      },
      {
        title: 'Gaming Ad Intelligence',
        titleCn: '游戏买量洞察',
        icon: 'game-ad',
        children: [
          { title: 'Ad Creatives', titleCn: '游戏素材', href: '/marketing/CompetitorsAdCreatives' },
          { title: 'Competitor Ad Comparison', titleCn: '竞品投放对比', href: '/marketing/CompetitorAdComparison' },
          { title: 'Creative Trends', titleCn: '素材热门趋势', href: '/marketing/CreativeTrends' },
        ],
      },
      // {
      //   title: 'Gaming Content Intelligence',
      //   titleCn: '游戏内容情报',
      //   icon: 'game-ad',
      //   children: [
      //     { title: 'UGC Trends', titleCn: 'UGC热门创意', href: '/marketing/UgcCreativeTrends' },
      //   ],
      // },
      {
        title: 'Game Genre Zone',
        titleCn: '品类游戏专区',
        icon: 'genre-zone',
        children: [
          {
            title: 'Arrows',
            titleCn: 'Arrows 专区',
            // icon: 'arrows-flow',
            children: [
              {
                title: 'Top Creatives',
                titleCn: '热门素材',
                href: '/marketing/Arrows/TopCreatives',
              },
              {
                title: 'Trending Posts & Videos',
                titleCn: '热门帖子&视频',
                href: '/marketing/Arrows/TrendingPublications',
              },
            ],
          },
          {
            title: 'Mahjong Solitaire',
            titleCn: '麻将拼图专区',
            // icon: 'mahjong',
            children: [
              {
                title: 'Top Creatives',
                titleCn: '热门素材',
                href: '/marketing/MahjongSolitaire/TopCreatives',
              },
              {
                title: 'Trending Posts & Videos',
                titleCn: '热门帖子&视频',
                href: '/marketing/MahjongSolitaire/TrendingPublications',
              },
            ],
          },
          {
            title: 'Merge-2',
            titleCn: '二合专区',
            // icon: 'arrows-flow',
            children: [
              {
                title: 'Top Creatives',
                titleCn: '热门素材',
                href: '/marketing/Merge2/TopCreatives',
              },
              {
                title: 'Trending Posts & Videos',
                titleCn: '热门帖子&视频',
                href: '/marketing/Merge2/TrendingPublications',
              },
            ],
          },
          {
            title: 'Merge-3',
            titleCn: '三消专区',
            // icon: 'arrows-flow',
            children: [
              {
                title: 'Top Creatives',
                titleCn: '热门素材',
                href: '/marketing/Merge3/TopCreatives',
              },
              {
                title: 'Trending Posts & Videos',
                titleCn: '热门帖子&视频',
                href: '/marketing/Merge3/TrendingPublications',
              },
            ],
          },
        ],
      },
    ],
    listMenuLoading: false,
  },
  reducers: {
    save(state: TStateType, { payload }) {
      return { ...state, ...payload };
    },
    toggleMenuExpand(state: TStateType, { payload = {} }) {
      return { ...state, menuExpand: !state.menuExpand, ...payload };
    },
  },
};

export default customModel;
